import React, { useState } from 'react';
import { useLocation } from 'react-router-dom';
import { SFNavLink } from '../../../SFNavLink';

export interface UseSFNavContentLinkProps {
  isCollapsed?: boolean;
  isPanel?: boolean;
  onDrawerClose?: () => void;
}

export interface UseSFNavContentLinkReturn {
  location: ReturnType<typeof useLocation>;
  open: boolean;
  menuOpen: boolean;
  anchorEl: HTMLElement | undefined;
  active: boolean;
  onClick: (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    link: SFNavLink
  ) => void;
  onCollapsedSubMenuButtonClick: (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
  onMenuClose: () => void;
  onMenuItemClick: (link: SFNavLink) => void;
}

export const UseSFNavContentLink = ({
  isCollapsed,
  isPanel,
  onDrawerClose
}: UseSFNavContentLinkProps) => {
  const location = useLocation();
  const [open, setOpen] = useState<boolean>(false);
  const [menuOpen, setMenuOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | undefined>(undefined);
  const [active, setActive] = useState<boolean>(false);

  const onClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>,
    link: SFNavLink
  ) => {
    if (isCollapsed && !isPanel && link.children && link.children.length > 0) {
      setAnchorEl(e.currentTarget);
      setMenuOpen(true);
      setActive(true);
    } else {
      link.onClick && link.onClick();

      if (isPanel) {
        if (link.children && link.children.length > 0) {
          onCollapsedSubMenuButtonClick(e);
        } else {
          onDrawerClose && onDrawerClose();
        }
      } else {
        if (!isCollapsed) {
          onCollapsedSubMenuButtonClick(e);
        }
      }
    }
  };

  const onCollapsedSubMenuButtonClick = (
    e: React.MouseEvent<HTMLButtonElement | HTMLDivElement, MouseEvent>
  ) => {
    e.preventDefault();
    e.stopPropagation();
    setOpen((o) => !o);
  };

  const onMenuClose = () => {
    setAnchorEl(undefined);
    setMenuOpen(false);
    setActive(false);
  };

  const onMenuItemClick = (link: SFNavLink) => {
    link.onClick && link.onClick();
    setAnchorEl(undefined);
    setMenuOpen(false);
    setActive(false);
  };

  return {
    location,
    open,
    menuOpen,
    anchorEl,
    active,
    onClick,
    onCollapsedSubMenuButtonClick,
    onMenuClose,
    onMenuItemClick
  };
};
